import type { CustomerFeedbackView } from "@slfinrtl/ui-bff-routes"
import { getCustomerFeedbackViewRoute } from "@slfinrtl/ui-bff-routes"
import { useEffect, useRef, useState } from "react"
import { useIntl } from "react-intl"
import { Stage } from "src/components"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useBff } from "src/hooks"
import { useScrollToStage } from "../../common/useScrollToStage/useScrollToStage"
import { useVehicleDetailsContext } from "../../context/VehicleDetailsContext"
import { CustomerFeedback } from "./components/CustomerFeedback"
import { CustomerFeedbackSkeleton } from "./components/CustomerFeedbackSkeleton"
import { customerFeedbackMessages } from "./components/customerFeedback.messages"

export const CustomerFeedbackContainer = withErrorHandler(() => {
	const { inventoryId } = useVehicleDetailsContext()
	const [customerFeedbackView, setCustomerFeedbackView] = useState<CustomerFeedbackView | null>()

	const ref = useRef(null)

	const { formatMessage } = useIntl()
	const fetchView = useBff(
		getCustomerFeedbackViewRoute,
		{
			body: undefined,
			pathParams: { inventoryId },
			queryParams: {},
		},
		"inline",
	)

	useScrollToStage({
		editStage: "customerFeedback",
		ref,
	})

	useEffect(() => {
		fetchView()
			.then(setCustomerFeedbackView)
			.catch(() => setCustomerFeedbackView(null))
	}, [fetchView, setCustomerFeedbackView])

	return (
		<Stage ref={ref} title={formatMessage(customerFeedbackMessages.headline)}>
			<ErrorNotificationInline dismissButton={false} />
			{customerFeedbackView === undefined ? (
				<CustomerFeedbackSkeleton />
			) : customerFeedbackView === null ? null : (
				<CustomerFeedback view={customerFeedbackView} />
			)}
		</Stage>
	)
})
